/* eslint-disable */
import lockScroll from '../__utils/lockScroll';
import breakpoints from '../__utils/breakpoints';

export const HEADER_ACTIVE_CLASS = 'mobile-open';
const BTN_ACTIVE_CLASS = 'open';
export const SUBNAV_ACTIVE_CLASS = 'subnav-open';
export const HEADER_SUBNAV_CLASS = 'header-subnav';
export const MENU_WRAPPER_CLASS = 'mega-menu-wrapper-open';

export const header = document.querySelector( '.main-header' );
const { body } = document;

const headerHandler = {
	trigger: null,
	parentLinks: [],
	backButtons: [],

	cacheDOM() {
		this.trigger = header.querySelector( '.js-mobile-header-trigger' );
		this.parentLinks = header.querySelectorAll(
			'.menu-item-object-ccs_custom_menu_item > a',
		);
		this.backButtons = header.querySelectorAll( '.js-close-mega-menu' );
	},

	bindEvents() {
		this.trigger &&
            this.trigger.addEventListener( 'click', () => this.toggleNav() );

		this.parentLinks.length &&
            this.parentLinks.forEach( ( el ) =>
            	el.addEventListener( 'click', this.toggleSubNav ),
            );

		this.backButtons.length &&
            this.backButtons.forEach( ( el ) =>
            	el.addEventListener( 'click', this.backButtonHandler ),
            );
	},

	toggleNav( blockBody = true ) {
		if ( header.classList.contains( HEADER_ACTIVE_CLASS ) ) {
			header.classList.remove( HEADER_ACTIVE_CLASS );
			this.trigger.classList.remove( BTN_ACTIVE_CLASS );

			if ( blockBody ) {
				lockScroll.unlock();
				body.classList.remove( 'overlayed' );
			}
		} else {
			header.classList.add( HEADER_ACTIVE_CLASS );
			this.trigger.classList.add( BTN_ACTIVE_CLASS );

			if ( blockBody ) {
				lockScroll.lock();
				body.classList.add( 'overlayed' );
			}
		}
	},

	backButtonHandler( e ) {
		e.target.closest( '.mega-menu-wrapper' ).previousElementSibling.click();
	},

	toggleSubNav( e ) {
		e.preventDefault();
		const _this = e.target;

		if ( _this.classList.contains( SUBNAV_ACTIVE_CLASS ) ) {
			_this.classList.remove( SUBNAV_ACTIVE_CLASS );
			header.classList.remove( MENU_WRAPPER_CLASS );

			if ( breakpoints.lgMin.matches ) {
				body.classList.remove( 'overlayed' );
				header.classList.remove( HEADER_SUBNAV_CLASS );
				lockScroll.unlock();
			}
		} else {
			if ( breakpoints.lgMin.matches ) {
				headerHandler.parentLinks.forEach( ( el ) =>
					el.classList.remove( SUBNAV_ACTIVE_CLASS ),
				);
				header.classList.remove( MENU_WRAPPER_CLASS );
				body.classList.add( 'overlayed' );
				header.classList.add( HEADER_SUBNAV_CLASS );
				lockScroll.lock();
			}
			_this.classList.add( SUBNAV_ACTIVE_CLASS );
			header.classList.add( MENU_WRAPPER_CLASS );
		}
	},

	hideOutSideClick( e ) {
		if ( ! header.contains( e.target ) ) {
			if ( header.classList.contains( HEADER_ACTIVE_CLASS ) ) {
				headerHandler.toggleNav();
			} else if ( header.classList.contains( HEADER_SUBNAV_CLASS ) ) {
				headerHandler.parentLinks.forEach( ( el ) =>
					el.classList.remove( SUBNAV_ACTIVE_CLASS ),
				);
				header.classList.remove( MENU_WRAPPER_CLASS );
				body.classList.remove( 'overlayed' );
				header.classList.remove( HEADER_SUBNAV_CLASS );
				lockScroll.unlock();
			}
		}
	},

	breakpointChange( e ) {
		const activeLink = header.querySelector( `.${ SUBNAV_ACTIVE_CLASS }` );

		if ( ! e.matches && header.classList.contains( HEADER_ACTIVE_CLASS ) ) {
			headerHandler.toggleNav();

			activeLink && activeLink.click();
		} else if (
			e.matches &&
            header.classList.contains( HEADER_SUBNAV_CLASS ) &&
            activeLink
		) {
			body.classList.remove( 'overlayed' );
			header.classList.remove( HEADER_SUBNAV_CLASS );
			lockScroll.unlock();
			activeLink.click();
		}
	},

	init() {
		if ( ! header ) {
			return;
		}

		this.cacheDOM();
		this.bindEvents();

		if ( breakpoints.lgMax.addListener ) {
			breakpoints.lgMax.addListener( ( e ) => this.breakpointChange( e ) );
		} else {
			breakpoints.lgMax.addEventListener( 'change', ( e ) =>
				this.breakpointChange( e ),
			);
		}
	},
};

export default headerHandler;
/* eslint-enable */
